import React, { createContext, useState, useEffect } from "react";

import RouteConstants from "../../../constants/routeConstants.json";
import { useNavigate, useLocation } from "react-router";
import ContentData from "../../../constants/contentFile.json";
import { spaceCheck, validateRoleName } from "../../../utils/service";
import {
  editRoleApi,
  getrolenFeatureApi,
  viewRoleDetail,
} from "../../../api/Api";
import { useCookies } from "react-cookie";

export const RoleEditContext = createContext({});

export const RoleEditContextProvider = ({ children }) => {
  const location = useLocation();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [validatedName, setValidatedName] = useState("");
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [userPermissionList, setUserPermissionList] = useState([]);
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [featuresData, setFeaturesData] = useState([]);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const roleId = location?.state?.id;

  // description validation
  const [validateDescription, setValidatedDescription] = useState("");

  useEffect(() => {
    viewRole(roleId);
    dataUserPermissionList();
  }, []);

  const navigator = useNavigate();

  const rolesList = () => {
    navigator(RouteConstants.ROLE_LIST);
  };
  // name validation
  const nameValidation = (value) => {
    if (value === "") {
      setValidatedName(ContentData.rolePermissions.enterRole);
      return false;
    } else if (spaceCheck(value)) {
      setValidatedName(ContentData.rolePermissions.nameSpaceCheckMessage);
      return false;
    } else {
      setValidatedName("");
      return true;
    }
  };

  // description  white space check
  const descriptionCheck = (value) => {
    if (value === "") {
      setValidatedDescription(ContentData.rolePermissions.descriptionMessage);
      return false;
    } else if (spaceCheck(value)) {
      setValidatedDescription(
        ContentData.rolePermissions.descriptionSpaceCheckMsg
      );
      return false;
    } else {
      setValidatedDescription("");
      return true;
    }
  };

  const handleRoleName = (e) => {
    e.preventDefault();
    const roleValue = e.target.value;
    if (validateRoleName(roleValue)) {
      setName(roleValue);
    } else if (roleValue === "") {
      setName("");
    }
  };

  const handleDescription = (e) => {
    e.preventDefault();
    const descriptionValue = e.target.value;
    if (descriptionValue.startsWith(" ")) {
      return;
    }
    setDescription(e.target.value);

    //descriptionCheck(e.target.value);
  };

  const dataUserPermissionList = async () => {
    try {
      setSpinnerStatus(true);
      const featureApiData = await getrolenFeatureApi();
      if (featureApiData?.data?.statusCode === 200) {
        setSpinnerStatus(false);
        setFeaturesData(featureApiData?.data?.data);
      }
    } catch (error) {
      // console.log(error);
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setSpinnerStatus(false);
      setErrorAlertShow(true);
      setErrorAlertMessage(errorMessage);
      setSuccessAlertShow(false);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
  };

  const newPermissionCategory = (id, key, value) => {
    setUserPermissionList((prevList) => {
      // Check if the feature already exists in the list
      const existingPermission = prevList.find(
        (item) => item.feature?._id === id
      );

      if (existingPermission) {
        return prevList.map((item) => {
          if (item.feature?._id === id) {
            if (key === "view") {
              // If "view" is toggled, only update the "view" property
              return {
                ...item,
                [key]: !value,
              };
            } else {
              // If other keys are toggled, update them and set "view" to true only if it's not already false
              return {
                ...item,
                [key]: !value,
                view: item.view || !value, // Ensure "view" stays true unless explicitly toggled off
              };
            }
          }
          return item;
        });
      } else {
        // Add a new feature if it doesn't exist in the list
        return [
          ...prevList,
          {
            feature: { _id: id },
            [key]: true,
            view: true,
          },
        ];
      }
    });
  };

  const roleToLogin = () => {
    removeCookie("x-access-token");
    navigator(RouteConstants.LOGIN);
  };

  const viewRole = async (id) => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await viewRoleDetail(id);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setSuccessAlertShow(false);
        setErrorAlertShow(false);
        setName(getDetailData.data.data.role?.name);
        setDescription(getDetailData.data.data.role?.description);
        setUserPermissionList(getDetailData.data.data.role?.permissions);
      }
    } catch (error) {
      setSuccessAlertShow(false);

      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setSpinnerStatus(false);
      setErrorAlertMessage(errorMessage);
      setErrorAlertShow(true);
      setSuccessAlertShow(false);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
  };

  const editRoleformValidation = async (e) => {
    e.preventDefault();

    // Map userPermissionList to modifyUserPermissionList
    const modifyUserPermissionList = userPermissionList.map((item) => ({
      feature: item.feature._id,
      edit: item.edit,
      delete: item.delete,
      add: item.add,
      view: item.view,
    }));

    const allPermissionsFalse = modifyUserPermissionList.every(
      (item) => !item.edit && !item.delete && !item.add && !item.view
    );

    const permissions = allPermissionsFalse ? [] : modifyUserPermissionList;

    const roleDetails = {
      name: name,
      description: description.trim(),
      permissions: permissions,
    };

    // Validate name and description
    const nameValidate = nameValidation(name);
    const descriptionValidate = descriptionCheck(description);

    if (nameValidate && descriptionValidate) {
      try {
        setSpinnerStatus(true);
        const getData = await editRoleApi(roleId, roleDetails);
        if (getData?.status === 200) {
          setSpinnerStatus(false);
          setSuccessAlertShow(true);
          setErrorAlertShow(false);
          setSuccessAlertMessage(
            getData?.data?.message
              ? getData?.data?.message
              : "Role created successfully"
          );
        }
      } catch (error) {
        const responseStatus = error?.response?.data?.statusCode;
        const errorMessage =
          error?.response?.data?.message || ContentData.tenantPage.wentWrong;

        setStatusValue(responseStatus);
        setSpinnerStatus(false);
        setErrorAlertMessage(errorMessage);
        setErrorAlertShow(true);
        setSuccessAlertShow(false);

        if (responseStatus === 400) {
          setButtonText(ContentData.tenantPage.tryAgain);
        } else if (responseStatus === 401 || responseStatus === 403) {
          setButtonText(ContentData.tenantPage.login);
        } else {
          setButtonText(ContentData.tenantPage.tryAgain);
        }
      }
    }
  };

  const roleDetailPage = (id) =>{
    navigator(RouteConstants?.VIEW_ROLE, {state : {id}})
  }

  const providerValue = {
    name,
    handleRoleName,
    validatedName,
    editRoleformValidation,
    userPermissionList,
    description,
    spinnerStatus,
    rolesList,
    handleDescription,
    errorAlertShow,
    errorAlertMessage,
    setErrorAlertShow,
    roleToLogin,
    buttonText,
    newPermissionCategory,
    statusValue,
    spinnerStatus,
    successAlertMessage,
    successAlertShow,
    validateDescription,
    featuresData,
    nameValidation,
    viewRole,
    roleId,
    roleDetailPage
  };
  return (
    <RoleEditContext.Provider value={providerValue}>
      {children}
    </RoleEditContext.Provider>
  );
};
